<div class="legal">
  <h1>Política de Privacidade</h1>
  <p class="updated">Última atualização: {{ info.updatedAt }}</p>

  <p>
    Esta política explica como o <strong>NCommerce</strong>, sistema de gestão para restaurantes, bares, lanchonetes
    e outros estabelecimentos de alimentação, trata dados pessoais em conformidade com a Lei Geral de Proteção de Dados
    Pessoais (Lei nº 13.709/2018, "LGPD"). Ela vale para o site <strong>ncommerce.app</strong>, para o cadastro, para o
    sistema instalado nos estabelecimentos e para as páginas públicas que os estabelecimentos oferecem aos seus clientes
    (pedidos online, cardápio digital, reservas, avaliações e acompanhamento de entrega).
  </p>

  <h2>1. Quem somos</h2>
  <p>
    O NCommerce é oferecido por <strong>{{ info.company }}</strong>, inscrita no CNPJ sob o nº {{ info.cnpj }},
    com sede em {{ info.address }} ("NCommerce", "nós").
  </p>
  <p>
    Encarregado pelo tratamento de dados pessoais: <strong>{{ info.dpo }}</strong>, pelo e-mail
    <a [href]="'mailto:' + info.privacyEmail">{{ info.privacyEmail }}</a>.
  </p>

  <h2>2. Nosso papel em cada situação</h2>
  <ul>
    <li>
      <strong>Controlador:</strong> quando tratamos dados de quem se interessa pelo NCommerce, se cadastra, contrata
      um plano ou fala com nosso suporte. Nesses casos, nós decidimos como os dados são usados.
    </li>
    <li>
      <strong>Operador:</strong> quando um estabelecimento usa o NCommerce para atender os próprios clientes (pedidos,
      reservas, avaliações, mensagens de WhatsApp, emissão de nota fiscal). O controlador desses dados é o
      estabelecimento, que decide para que eles servem; nós os tratamos em nome dele e conforme as instruções dele.
      Se você é cliente de um restaurante, dúvidas e pedidos sobre seus dados devem ser feitos primeiro ao próprio
      restaurante. Se o restaurante não responder, você também pode nos procurar.
    </li>
  </ul>

  <h2>3. Quais dados tratamos</h2>

  <h3>3.1. Interessados e donos de estabelecimento</h3>
  <ul>
    <li>Nome, e-mail e número de WhatsApp informados ao pedir o cadastro;</li>
    <li>Dados da conta: nome, e-mail, senha (guardada apenas de forma criptografada) e, se você entrar com o Google,
      o identificador da sua conta Google, seu nome e e-mail;</li>
    <li>Dados pessoais do responsável (como CPF e contato) e dados da empresa (razão social, nome fantasia, CNPJ,
      endereço), usados no contrato e na cobrança;</li>
    <li>Plano escolhido, histórico de pagamentos e faturas;</li>
    <li>Registro do aceite do contrato e destes documentos: versão aceita, data e hora, endereço IP e navegador;</li>
    <li>Informações técnicas do computador onde o sistema é instalado (sistema operacional, nome do computador,
      identificadores de instalação e de acesso remoto);</li>
    <li>Conversas com o suporte, por chat, e-mail ou WhatsApp.</li>
  </ul>

  <h3>3.2. Funcionários e usuários do sistema no estabelecimento</h3>
  <ul>
    <li>Nome, usuário de acesso e, quando o estabelecimento cadastrar, CPF e outros dados de funcionários.
      Esses dados ficam no computador do estabelecimento e nas cópias de segurança dele.</li>
  </ul>

  <h3>3.3. Clientes dos estabelecimentos</h3>
  <ul>
    <li>Nome, telefone, e-mail, endereço e localização de entrega, informados ao fazer um pedido online ou reserva;</li>
    <li>Itens pedidos, forma de pagamento, situação do pedido e localização do entregador durante a entrega;</li>
    <li>Respostas a avaliações e pesquisas de satisfação;</li>
    <li>Mensagens trocadas pelo WhatsApp com o número do estabelecimento ou do NCommerce sobre pedidos e reservas;</li>
    <li>CPF ou CNPJ, quando informado para constar na nota fiscal;</li>
    <li>Pedidos feitos em plataformas parceiras integradas, como o iFood, quando o estabelecimento ativar a integração.</li>
  </ul>

  <h3>3.4. Navegação no site</h3>
  <ul>
    <li>Endereço IP, data e hora de acesso, navegador e páginas visitadas;</li>
    <li>Informações guardadas no seu navegador para o site funcionar (por exemplo, o carrinho de compras e a sessão
      de login) e cookies de medição de audiência (Google Analytics);</li>
    <li>Contagem de visitas ao cardápio digital e ao site de reservas de cada estabelecimento, usada para os limites
      dos planos.</li>
  </ul>

  <h2>4. Para que usamos os dados e com qual base legal</h2>
  <table>
    <thead>
      <tr><th>Finalidade</th><th>Base legal (LGPD, art. 7º)</th></tr>
    </thead>
    <tbody>
      <tr>
        <td>Enviar o link de cadastro e falar com quem pediu informações sobre o NCommerce</td>
        <td>Procedimentos preliminares a contrato, a pedido do titular (inciso V)</td>
      </tr>
      <tr>
        <td>Criar e manter sua conta, instalar, atualizar e dar suporte ao sistema, cobrar o plano</td>
        <td>Execução de contrato (inciso V)</td>
      </tr>
      <tr>
        <td>Avisar sobre limites do plano, pagamentos pendentes, mudanças nos serviços e nestes documentos</td>
        <td>Execução de contrato (inciso V)</td>
      </tr>
      <tr>
        <td>Guardar registros de acesso, emitir notas fiscais e cumprir obrigações fiscais e contábeis</td>
        <td>Cumprimento de obrigação legal ou regulatória (inciso II), incluindo o Marco Civil da Internet</td>
      </tr>
      <tr>
        <td>Prevenir fraudes e abusos (como a verificação contra robôs), garantir a segurança e melhorar o sistema</td>
        <td>Legítimo interesse (inciso IX)</td>
      </tr>
      <tr>
        <td>Medir a audiência do site com o Google Analytics</td>
        <td>Legítimo interesse (inciso IX), com dados agregados</td>
      </tr>
      <tr>
        <td>Guardar provas do aceite do contrato e defender nossos direitos</td>
        <td>Exercício regular de direitos (inciso VI)</td>
      </tr>
      <tr>
        <td>Processar pedidos, reservas, avaliações e entregas dos clientes dos estabelecimentos</td>
        <td>Definida pelo estabelecimento, como controlador; em geral, execução de contrato com o cliente dele</td>
      </tr>
    </tbody>
  </table>
  <p>Não vendemos dados pessoais e não os usamos para publicidade de terceiros.</p>

  <h2>5. Com quem compartilhamos</h2>
  <p>Compartilhamos dados apenas com quem precisa deles para prestar o serviço:</p>
  <ul>
    <li><strong>O estabelecimento</strong> em que você fez pedido, reserva ou avaliação;</li>
    <li><strong>Amazon Web Services (AWS):</strong> guarda das cópias de segurança e envio de e-mails;</li>
    <li><strong>Google:</strong> login com Google, mapas e cálculo de endereços, medição de audiência;</li>
    <li><strong>Cloudflare:</strong> verificação contra robôs (Turnstile) e proteção de conexões;</li>
    <li><strong>Z-API:</strong> envio e recebimento de mensagens de WhatsApp;</li>
    <li><strong>Asaas:</strong> emissão de cobranças e recebimento de pagamentos dos planos;</li>
    <li><strong>Vercel:</strong> hospedagem do site;</li>
    <li><strong>AnyDesk:</strong> acesso remoto ao computador do estabelecimento para suporte;</li>
    <li><strong>iFood e outras plataformas</strong> que o estabelecimento decidir integrar;</li>
    <li><strong>Secretarias da Fazenda (SEFAZ):</strong> envio das notas fiscais emitidas pelo estabelecimento;</li>
    <li><strong>Autoridades públicas</strong>, quando a lei ou uma ordem judicial exigir.</li>
  </ul>
  <p>
    Esses parceiros só podem usar os dados para a finalidade contratada e precisam protegê-los. Alguns deles guardam
    dados fora do Brasil, em países como os Estados Unidos. Essas transferências seguem o art. 33 da LGPD e se apoiam
    em cláusulas contratuais e garantias de proteção oferecidas por esses fornecedores.
  </p>

  <h2>6. Onde ficam os dados do estabelecimento</h2>
  <p>
    O NCommerce é instalado no computador do próprio estabelecimento, e os dados do dia a dia (vendas, clientes,
    estoque, funcionários, notas fiscais) ficam nesse computador. Para que nada se perca, guardamos cópias de segurança
    criptografadas em nossos servidores na nuvem. Pedidos online, reservas, cardápio digital e avaliações passam pelos
    nossos servidores antes de chegar ao estabelecimento.
  </p>
  <p>
    Para instalar, atualizar e dar suporte, nossa equipe pode acessar o computador do estabelecimento remotamente.
    Fazemos isso somente para essas finalidades, e o acesso fica restrito à equipe do NCommerce.
  </p>

  <h2>7. Por quanto tempo guardamos</h2>
  <ul>
    <li>Pedidos de cadastro que não viraram conta: até 12 meses após o último contato;</li>
    <li>Conta, contrato e pagamentos: enquanto o contrato durar e, depois, pelo prazo exigido pela legislação fiscal e
      civil (em geral, 5 anos);</li>
    <li>Registros de acesso ao site: no mínimo 6 meses, como exige o Marco Civil da Internet;</li>
    <li>Mensagens de WhatsApp e dados de clientes dos estabelecimentos nos nossos servidores: enquanto forem
      necessários para o atendimento e pelo tempo definido pelo estabelecimento; ao fim do contrato, são excluídos,
      salvo obrigação legal de guarda;</li>
    <li>Cópias de segurança: são substituídas pelas mais novas e excluídas após o fim do contrato.</li>
  </ul>

  <h2>8. Como protegemos</h2>
  <p>
    Usamos conexões criptografadas (HTTPS), senhas guardadas com criptografia, controle de acesso por credenciais
    individuais, verificação contra robôs e acesso restrito aos servidores. Nenhum sistema é totalmente imune a falhas;
    se acontecer um incidente de segurança que possa trazer risco ou dano relevante, avisaremos os afetados e a
    Autoridade Nacional de Proteção de Dados (ANPD), como determina a LGPD.
  </p>
  <p>
    O estabelecimento é responsável pela segurança física do computador onde o sistema está instalado e por trocar a
    senha padrão de administrador após a instalação.
  </p>

  <h2>9. Seus direitos</h2>
  <p>Pela LGPD (art. 18), você pode pedir:</p>
  <ul>
    <li>confirmação de que tratamos seus dados e acesso a eles;</li>
    <li>correção de dados incompletos, inexatos ou desatualizados;</li>
    <li>anonimização, bloqueio ou eliminação de dados desnecessários ou tratados em desacordo com a lei;</li>
    <li>portabilidade dos dados a outro fornecedor;</li>
    <li>eliminação dos dados tratados com base no seu consentimento;</li>
    <li>informação sobre com quem compartilhamos seus dados;</li>
    <li>revisão de decisões tomadas apenas com base em tratamento automatizado;</li>
    <li>revogação do consentimento, quando ele for a base do tratamento.</li>
  </ul>
  <p>
    Para exercer esses direitos, escreva para <a [href]="'mailto:' + info.privacyEmail">{{ info.privacyEmail }}</a>.
    Podemos pedir informações para confirmar sua identidade. Respondemos em até 15 dias. Se o pedido for sobre dados
    que tratamos em nome de um estabelecimento, encaminharemos a ele. Você também pode reclamar à ANPD
    (<a href="https://www.gov.br/anpd" target="_blank" rel="noopener">gov.br/anpd</a>).
  </p>

  <h2>10. Cookies e armazenamento no navegador</h2>
  <ul>
    <li><strong>Necessários:</strong> guardam o carrinho, a sessão de login e preferências; sem eles o site não funciona.</li>
    <li><strong>Segurança:</strong> a verificação contra robôs da Cloudflare pode usar cookies próprios.</li>
    <li><strong>Medição:</strong> o Google Analytics usa cookies para contar visitas e entender como o site é usado.</li>
  </ul>
  <p>Você pode apagar ou bloquear cookies nas configurações do navegador; algumas partes do site podem parar de funcionar.</p>

  <h2>11. Crianças e adolescentes</h2>
  <p>
    O cadastro e a contratação do NCommerce são destinados a empresas, representadas por maiores de 18 anos. Não
    coletamos intencionalmente dados de menores de idade para esse fim.
  </p>

  <h2>12. Mudanças nesta política</h2>
  <p>
    Podemos atualizar esta política. A data no topo mostra a última versão. Quando a mudança for relevante, avisaremos
    os clientes por e-mail ou WhatsApp antes de ela valer.
  </p>

  <h2>13. Contato</h2>
  <p>
    {{ info.company }} — CNPJ {{ info.cnpj }}<br>
    {{ info.address }}<br>
    Privacidade: <a [href]="'mailto:' + info.privacyEmail">{{ info.privacyEmail }}</a><br>
    Contato geral: <a [href]="'mailto:' + info.contactEmail">{{ info.contactEmail }}</a>
  </p>
  <p>Veja também os <a routerLink="/termos">Termos de Uso</a>.</p>
</div>
